<template>
	<div class="left_center radio-div" @click="selfClick">
		<span class="iconfont radio" :style="'color:'+color+';'" :class="{'icon-radio':isCheck,'icon-RadioButton':!isCheck}"></span>
		<span class="radio-label font-65">{{label}}</span>
	</div>
</template>

<script>
	export default {
		name: "XhyRadio",
		/**
		 * 显示的名称 对应的数值  是否选中
		 */
		props: {
			color: {
				type: String,
				default: '#00FF00'
			},
			label: {
				type: String,
				default: ''
			},
			checked: {
				type: Boolean,
				default: false
			},
			value: {
				type: [String, Boolean],
				default: ''
			},
			readonly:{
				type:Boolean,
				default:false
			}
		},
		inject: ['xhyRadioGroup'],
		data() {
			return {
				isCheck: false
			}
		},
		created() {
			this.isCheck = this.checked;
		},
		methods: {
			/**
			 * 当前点击，向上级传递数据
			 */
			selfClick() {
				if(this.readonly){
					return;
				}
				if (!this.isCheck) {
					this.isCheck = !this.isCheck;
					if(this.xhyRadioGroup){
						this.xhyRadioGroup.setSelect(this.value !== '' ? this.value : this.label);
					}
					this.$emit('itemClick');
				}
			},
			setRadioStatus(status) {
				this.isCheck = status;
			}
		}
	}
</script>

<style scoped>
	@import url("../../../static/xhy-radio/xhy-iconfont.css");

	.radio {
		width: .9rem;
		height: .9rem;
		margin: .15rem .55rem 0 0;
		display: inline-block;
	}

	.radio-div {
		width: 50%;
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		margin-top:.6rem;
		/* min-width: 230upx; */
		/* margin-right: 10upx; */
	}
	.radio-label{
		width: calc(100% - 1.5rem);
		line-height: 1.2rem;
		font-size: .8rem;
		display: inline-block;
	}
</style>



// WEBPACK FOOTER //
// src/components/xhy-radio/xhy-radio.vue